export function ImgSubAgent({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Robot head */}
      <rect x="3" y="5" width="14" height="11" rx="3" />
      {/* Antenna */}
      <line x1="10" y1="5" x2="10" y2="2" />
      <circle cx="10" cy="1.5" r="1" fill="currentColor" stroke="none" />
      {/* Eyes */}
      <circle cx="7.5" cy="10" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12.5" cy="10" r="1.2" fill="currentColor" stroke="none" />
      {/* Mouth */}
      <line x1="7.5" y1="13" x2="12.5" y2="13" />
    </svg>
  );
}
